import "./SimpleNotification.scss";

export type StandardNotificationProps = {
    title: string;
    subtitle?: string;
};

export default ({ title, subtitle }: StandardNotificationProps) => {
    return (
        <div className="simpleNotification">
            <div className="title">{title}</div>
            {subtitle && <div className="subtitle">{subtitle}</div>}
        </div>
    );
};
